import React from "react";
import { cn } from "../../../lib/utils";
import "../AgenticGateway.css";

interface GatewayStatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  subtitle?: string;
  colorClass?: string;
  className?: string;
}

export default function GatewayStatCard({ icon, label, value, subtitle, colorClass = "text-primary", className }: GatewayStatCardProps) {
  return (
    <div className={cn("ag-stat", className)}>
      <span className={cn("ag-stat-icon", colorClass)} aria-hidden="true">
        {icon}
      </span>
      <div className="ag-stat-copy">
        <span className="ag-stat-value">{value}</span>
        <span className="ag-stat-label">{label}</span>
        {subtitle && <span className="ag-stat-subtitle">{subtitle}</span>}
      </div>
    </div>
  );
}
